import { Provider } from "jotai/react";

import { store } from "#/store";

import type { PropsWithChildren } from "react";

const AppJotaiProvider = (props: PropsWithChildren) => {
  const { children } = props;

  return <Provider store={store}>{children}</Provider>;
};

export default AppJotaiProvider;
